import type { HTMLAttributes } from 'types';
import { cn } from 'utils/classNames';

import { type GetBasePriceTextProps, useBasePriceText } from './helpers';

interface Props
	extends GetBasePriceTextProps, HTMLAttributes<HTMLParagraphElement> {}

/**
 * Displays different texts describing the base price, depending on the price
 * type and the current market.
 *
 * @see useBasePriceText()
 */
export default function BasePriceText({
	basePrice: basePriceProp,
	basePriceKey,
	className,
	displayedPriceType,
	recentLowestPriceKey,
	...attrs
}: Props) {
	const basePriceText = useBasePriceText({
		basePrice: basePriceProp,
		basePriceKey,
		displayedPriceType,
		recentLowestPriceKey,
	});

	if (basePriceText) {
		const { srLabel, text } = basePriceText;
		return (
			<>
				<p
					{...attrs}
					className={cn('font-body', className)}
					dangerouslySetInnerHTML={{ __html: text }}
					aria-hidden={srLabel ? true : undefined}
				/>
				{srLabel && <span className="sr-only">{srLabel}</span>}
			</>
		);
	}

	return null;
}
BasePriceText.displayName = 'BasePriceText';
